<script setup>
import { ref, onMounted } from 'vue'

const props = defineProps({
  activeTab: {
    type: String,
    required: true
  }
})

// System information
const systemInfo = ref({
  version: '1.0.0',
  buildDate: new Date().toLocaleDateString(),
  environment: 'production',
  nodeVersion: '18.x',
  database: 'MySQL 8.0'
})

// About information
const aboutInfo = ref({
  appName: 'OddsComposer',
  version: '1.0.0',
  description: 'Advanced odds composition and projection platform',
  copyright: '© 2025 OddsComposer. All rights reserved.'
})

onMounted(() => {
  // Load system information if needed
})
</script>

<template>
  <div class="space-y-6">
    <!-- System Information -->
    <div v-if="activeTab === 'system'" class="bg-white rounded-xl shadow-sm border border-gray-200 p-8">
      <div class="mb-6">
        <h2 class="text-2xl font-bold text-gray-900 mb-2">System Information</h2>
        <p class="text-gray-600">View system details and status</p>
      </div>

      <div class="space-y-4">
        <div class="grid grid-cols-2 gap-6">
          <div class="p-4 bg-gray-50 rounded-lg">
            <div class="text-sm text-gray-500 mb-1">Version</div>
            <div class="text-lg font-semibold text-gray-900">{{ systemInfo.version }}</div>
          </div>
          <div class="p-4 bg-gray-50 rounded-lg">
            <div class="text-sm text-gray-500 mb-1">Build Date</div>
            <div class="text-lg font-semibold text-gray-900">{{ systemInfo.buildDate }}</div>
          </div>
          <div class="p-4 bg-gray-50 rounded-lg">
            <div class="text-sm text-gray-500 mb-1">Environment</div>
            <div class="text-lg font-semibold text-gray-900">{{ systemInfo.environment }}</div>
          </div>
          <div class="p-4 bg-gray-50 rounded-lg">
            <div class="text-sm text-gray-500 mb-1">Node Version</div>
            <div class="text-lg font-semibold text-gray-900">{{ systemInfo.nodeVersion }}</div>
          </div>
          <div class="p-4 bg-gray-50 rounded-lg">
            <div class="text-sm text-gray-500 mb-1">Database</div>
            <div class="text-lg font-semibold text-gray-900">{{ systemInfo.database }}</div>
          </div>
        </div>
      </div>
    </div>

    <!-- About -->
    <div v-if="activeTab === 'about'" class="bg-white rounded-xl shadow-sm border border-gray-200 p-8">
      <div class="mb-6">
        <h2 class="text-2xl font-bold text-gray-900 mb-2">About</h2>
        <p class="text-gray-600">Application information and details</p>
      </div>

      <div class="space-y-6">
        <div class="text-center py-8">
          <div class="w-24 h-24 bg-pink-100 rounded-2xl flex items-center justify-center mx-auto mb-6">
            <i class="fas fa-cog text-pink-600 text-4xl"></i>
          </div>
          <h3 class="text-3xl font-bold text-gray-900 mb-2">{{ aboutInfo.appName }}</h3>
          <p class="text-gray-600 mb-4">{{ aboutInfo.description }}</p>
          <div class="text-sm text-gray-500">Version {{ aboutInfo.version }}</div>
        </div>

        <div class="pt-6 border-t border-gray-200">
          <div class="text-center text-sm text-gray-500">
            {{ aboutInfo.copyright }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
